<app-tablepage-base [loading]="loading">
  <p-table [value]="alerts"
           [paginator]="true" [rows]="25" [rowsPerPageOptions]="[10, 25, 50]"
           [scrollable]="true" scrollHeight="flex"
           [globalFilterFields]="['name']"
           stripedRows
           #dt
           class="flex h-full min-h-0 flex-col">
    <ng-template #caption>
      <div class="flex items-center justify-between">
        <div class="flex flex-col gap-1">
          <span class="text-xl font-bold">{{ 'titles.listAlerts' | translate }}</span>
          <div class="flex gap-2 text-base">
            <span class="capitalize">{{ 'toAnalyse' | translate }}:</span>
            <span class="text-red-600">{{ newAlerts }}</span>
          </div>
        </div>
        <div class=" inline-flex gap-2">
          <div class="flex">
            <input pInputText type="text" (input)="dt.filterGlobal($any($event.target).value, 'contains')" placeholder="{{ 'search' | translate }}..." />
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template #header>
      <tr>
        <th pSortableColumn="name" style="width: 20%">
          <div class="flex items-center gap-2">
            {{ 'name' | translate }}
            <p-sort-icon field="name" />
          </div>
        </th>
        <th pSortableColumn="timeStamp" style="width: 15%">
          <div class="flex items-center gap-2">
            {{ 'date' | translate }}
            <p-sort-icon field="timeStamp" />
          </div>
        </th>
        <th style="width: 40%">{{ 'alert' | translate}}</th>
        <th style="width: 15%">{{ 'value' | translate}}</th>
        <th pSortableColumn="isChecked" style="width: 15%">
          <div class="flex items-center justify-center gap-2">
            {{ 'verified' | translate}}
            <p-sort-icon field="isChecked" />
          </div>
        </th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template #body let-alert>
      <tr>
        <td>{{ alert.name }}</td>
        <td>{{ alert.timeStamp | statusDate }}</td>
        <td>{{ 'alertCodes.' + alert.description | translate }}</td>
        <td>{{ getAlertValue(alert) }}</td>
        <td>
          @if(alert.isChecked) {
          <div class="flex justify-center">
            <i class="pi pi-check"></i>
          </div>
          }
        </td>
        <td>
          <div class="flex justify-end">
            <p-button icon="pi pi-pencil" (click)="onAlertEdit(alert)"></p-button>
          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template #emptymessage>
      <tr>
        <td colspan="5">{{ 'primeng.emptyMessage' | translate }}</td>
      </tr>
    </ng-template>
  </p-table>

  <app-alert-dialog [messageService]="messageService"
                    [(visible)]="showDialog"
                    [alert]="selectedAlert"
                    (closed)="onAlertDialogClosed($event)">
  </app-alert-dialog>

</app-tablepage-base>
